/**
 * One CSV cell. Quoted when needed; a leading = + - @ is defused so a name or
 * email a user typed can't run as a formula when the file is opened in Excel.
 */
export const csvCell = (value: unknown) => {
  let text = value === undefined || value === null ? "" : String(value);
  if (/^[=+\-@\t\r]/.test(text)) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** A CSV file: the header line, then one line per row. */
export const toCsvText = (header: unknown[], rows: unknown[][]) =>
  [header, ...rows].map((line) => line.map(csvCell).join(",")).join("\n");

/** Save `content` as a file: CSV text, or a ready-made file such as an .xlsx. */
export const downloadFile = (name: string, content: string | Blob) => {
  const url = URL.createObjectURL(
    typeof content === "string"
      ? new Blob([content], { type: "text/csv;charset=utf-8" })
      : content,
  );
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

/** "2026-10-28", or empty. */
export const isoDate = (value?: string | null) =>
  value ? new Date(value).toISOString().slice(0, 10) : "";
